var $f1ab51510712db52$exports = {};
$f1ab51510712db52$exports = {
  "longPressMessage": "\u9577\u62BC\u3057\u307E\u305F\u306F Alt+\u4E0B\u77E2\u5370\u30AD\u30FC\u3067\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F"
};
export { $f1ab51510712db52$exports as default };